/*
 * Booksy 2026-11-01 – Impulse 10.0.0 változatváltó pótlás.
 * A termékoldal még a 8.2.1-es jelölést használja (variant-button / [data-variant-json] / select[data-product-select]),
 * a 10.0.0 theme.js-ből viszont kikerült a theme.Variants. Ma ezt csak az ajándékutalvány (8 címlet) használja.
 * Ha a theme.Variants létezik (8.2.1), a szkript nem csinál semmit.
 */
(function () {
  if (window.theme && theme.Variants) return;

  function money(cents) {
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) {}
    return (cents / 100).toFixed(2).replace('.', ',') + ' lei';
  }

  function containerOf(json) {
    var el = json.parentElement;
    while (el && !el.querySelector('select[data-product-select]')) el = el.parentElement;
    return el;
  }

  function selectedOptions(container) {
    var groups = container.querySelectorAll('.variant-wrapper');
    var values = [];
    groups.forEach(function (g) {
      var checked = g.querySelector('input[data-variant-input]:checked');
      var select = g.querySelector('select[data-variant-input]');
      values.push(checked ? checked.value : select ? select.value : null);
    });
    return values;
  }

  function init(json) {
    var container = containerOf(json);
    if (!container || container.dataset.booksyVariantShim) return;
    container.dataset.booksyVariantShim = '1';
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var master = container.querySelector('select[data-product-select]');

    container.addEventListener('change', function (evt) {
      if (!evt.target.matches('[data-variant-input]')) return;
      var opts = selectedOptions(container);
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || opts[i] === o; });
      });
      if (!variant) return;

      master.value = variant.id;
      master.dispatchEvent(new Event('change', { bubbles: true }));

      var price = container.querySelector('[data-product-price]');
      if (price) price.textContent = money(variant.price);

      var btn = container.querySelector('[data-add-to-cart]');
      var btnText = container.querySelector('[data-add-to-cart-text]');
      if (btn) btn.disabled = !variant.available;
      if (btnText && window.theme && theme.strings) {
        btnText.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({ path: url.toString() }, '', url.toString());
      } catch (e) {}

      var detail = { variant: variant, value: evt.target.value, index: evt.target.parentElement && evt.target.parentElement.dataset.index };
      container.dispatchEvent(new CustomEvent('variantChange', { detail: detail }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: detail }));
    });
  }

  function run() { document.querySelectorAll('[data-variant-json]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
